import handleMultipleArgs from './_handleMultipleArgs';
import processHeaders from './_processHeaders';
import defaultPOST from './_defaultPOST';
import fetch from './fetch';

/**
 * @public
 * Makes an AJAX request through `fetch`
 *
 * @param {Object} args: options to configure the request.
 *        It has the properties: {url, method, headers, data, credentials}
 * @throws {Error} with the URL of the failed request.
 * @return {Promise}
 */
export default function fetchJSON(...args) {
  const config = defaultPOST(handleMultipleArgs(args));

  return fetch(config).then((body) => {
    let data = body.response;
    const isJSON = processHeaders.hasJSON(body.headers);

    if (isJSON) {
      data = data && JSON.parse(data);
    }

    return data;
  });
}
